<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 11 14">
    <path d="M10.141 10.328c0 0.195-0.078 0.391-0.219 0.531l-1.062 1.062c-0.141 0.141-0.336 0.219-0.531 0.219s-0.391-0.078-0.531-0.219l-2.297-2.297-2.297 2.297c-0.141 0.141-0.336 0.219-0.531 0.219s-0.391-0.078-0.531-0.219l-1.062-1.062c-0.141-0.141-0.219-0.336-0.219-0.531s0.078-0.391 0.219-0.531l2.297-2.297-2.297-2.297c-0.141-0.141-0.219-0.336-0.219-0.531s0.078-0.391 0.219-0.531l1.062-1.062c0.141-0.141 0.336-0.219 0.531-0.219s0.391 0.078 0.531 0.219l2.297 2.297 2.297-2.297c0.141-0.141 0.336-0.219 0.531-0.219s0.391 0.078 0.531 0.219l1.062 1.062c0.141 0.141 0.219 0.336 0.219 0.531s-0.078 0.391-0.219 0.531l-2.297 2.297 2.297 2.297c0.141 0.141 0.219 0.336 0.219 0.531z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-times.html